import { Sponsor, SponsorLevel, SponsorLevelWithSponsors } from '@/entities/Sponsor';
import { SponsorDto, SponsorLevelWithSponsorsDto } from '@/infrastructure/network/dto';

const sponsorLevelDtoToSponsorLevel = (level: string): SponsorLevel => {
	switch (level) {
		case '1': {
			return SponsorLevel.GOLD;
		}
		case '2': {
			return SponsorLevel.SILVER;
		}
		case '3': {
			return SponsorLevel.PLATINUM;
		}
		case '5': {
			return SponsorLevel.BRONZE;
		}
		case '6': {
			return SponsorLevel.PARTNER;
		}
		case '7': {
			return SponsorLevel.NO_LEVEL;
		}
		case '8': {
			return SponsorLevel.TOUR;
		}
		case '9': {
			return SponsorLevel.PLATINUM_PADDLE;
		}
		case '10': {
			return SponsorLevel.GOLD_PADDLE;
		}
		case '11': {
			return SponsorLevel.SILVER_PADDLE;
		}
		case '12': {
			return SponsorLevel.TITLE_SPONSOR;
		}
		default: {
			return SponsorLevel.NO_LEVEL;
		}
	}
};

export const sponsorDtoToSponsor = (dto: SponsorDto): Sponsor => {
	return {
		...dto,
		sponsorLevelId: sponsorLevelDtoToSponsorLevel(dto.sponsorLevelId),
		dateCreated: new Date(dto.dateCreated),
		dateDisabled: dto.dateDisabled ? new Date(dto.dateDisabled) : null
	};
};

export const sponsorLevelWithSponsorsDtoToSponsorLevelWithSponsors = (dto: SponsorLevelWithSponsorsDto): SponsorLevelWithSponsors => {
	return {
		sponsorLevelId: sponsorLevelDtoToSponsorLevel(dto.sponsorLevelId),
		sponsorLevelTitle: dto.sponsorLevelTitle,
		systemSponsors: dto.systemSponsors.map(sponsorDtoToSponsor)
	};
};
